document.addEventListener('DOMContentLoaded', () => {
  // Open sidebar
  document.querySelectorAll('.open-sidebar').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.getAttribute('data-target');
      document.getElementById(id)?.classList.add('active');
    });
  });

  // Close sidebar from button or clicking outside
  document.querySelectorAll('.sidebar-overlay').forEach(overlay => {
    overlay.addEventListener('click', (e) => {
      const popup = overlay.querySelector('.sidebar-popup');
      if (!popup.contains(e.target)) {
        overlay.classList.remove('active');
      }
    });
  });

  document.querySelectorAll('.close-sidebar').forEach(button => {
    button.addEventListener('click', () => {
      const id = button.getAttribute('data-target');
      document.getElementById(id)?.classList.remove('active');
    });
  });
});